import React, { ReactNode } from 'react';
import { DragOverlay } from '@wix/patterns-dnd-kit-core';
import { useDragAndDropContext } from './DragAndDropContext';
import { restrictToWindowEdges } from '@wix/patterns-dnd-kit-modifiers';
import { useDefaultDragOverlayProps } from './useDefaultDragOverlayProps';

export function TableRowDragOverlay({ children }: { children?: ReactNode }) {
  const { dropAnimation, DragOverlayComponentType = DragOverlay } =
    useDragAndDropContext();

  const defaultProps = useDefaultDragOverlayProps();

  return (
    <DragOverlayComponentType
      {...defaultProps}
      dropAnimation={dropAnimation}
      modifiers={[restrictToWindowEdges]}
    >
      {children}
    </DragOverlayComponentType>
  );
}
